import { useContext, useState } from 'react';
import { ModalsContext } from './Context';
import { SharePacketModal } from '../Modals/SharePacketModal';
import { CreateOrRenameCollectionModal } from '../Modals/CreateOrRenameCollectionModal';
import { DeleteConfirmationModal } from '../Modals/DeleteConfirmationModal';
import { CollectionsSidebarMobile } from '../Modals/MobileCollectionsSidebar';
import { ShareFolderModal } from '../Modals/ShareFolderModal';

export const useMyResourcesModals = () => {
  const context = useContext(ModalsContext);
  if (!context) {
    throw new Error('useMyResourcesModals must be used within a PacketModalsProvider');
  }
  return context;
};

export const ModalsProvider = ({ children, onCollectionRename, onCollectionDeleted }) => {
  const [sharePacketModalOpen, setSharePacketModalOpen] = useState(null); // null || {packet: packet}
  const [shareProjectModalOpen, setShareProjectModalOpen] = useState(null); // null || {project: project}
  const [showCreateOrRenameCollectionModal, setShowCreateOrRenameCollectionModal] = useState(null); // null || {existingCollection: collection || null}
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(null); // null || {type: str, item: relatedObj, onSuccess: fn}
  const [showCollectionSidebarMobile, setShowCollectionSidebarMobile] = useState(null); // null || {collection: collection}
  const [shareCollectionModalOpen, setShareCollectionModalOpen] = useState(null); // null || {collection: collection}
  return (
    <ModalsContext.Provider
      value={{
        setSharePacketModalOpen,
        setShareProjectModalOpen,
        setShowCreateOrRenameCollectionModal,
        setShowDeleteConfirmationModal,
        setShowCollectionSidebarMobile,
        setShareCollectionModalOpen,
      }}>
      {showCreateOrRenameCollectionModal && (
        <CreateOrRenameCollectionModal
          onClose={() => setShowCreateOrRenameCollectionModal(null)}
          onRename={(collectionId, newTitle) => {
            onCollectionRename?.(collectionId, newTitle);
          }}
          collection={showCreateOrRenameCollectionModal.collection}
          source='my_resources'
        />
      )}
      {shareProjectModalOpen && (
        <SharePacketModal
          packet={shareProjectModalOpen.project}
          isProject={true}
          onClose={() => setShareProjectModalOpen(null)}
        />
      )}
      {sharePacketModalOpen && (
        <SharePacketModal
          packet={sharePacketModalOpen.packet}
          onClose={() => setSharePacketModalOpen(null)}
        />
      )}
      {showDeleteConfirmationModal && (
        <DeleteConfirmationModal
          onClose={() => setShowDeleteConfirmationModal(null)}
          config={showDeleteConfirmationModal}
        />
      )}
      {showCollectionSidebarMobile && (
        <CollectionsSidebarMobile
          onClose={() => setShowCollectionSidebarMobile(null)}
          onCollectionDeleted={onCollectionDeleted}
        />
      )}
      {/* The folder share modal offers invite-by-email + copy link (parity with the folder page's
          Invite modal). */}
      {shareCollectionModalOpen && (
        <ShareFolderModal
          collection={shareCollectionModalOpen.collection}
          onClose={() => setShareCollectionModalOpen(null)}
        />
      )}
      {children}
    </ModalsContext.Provider>
  );
};
